import {
	CLOSE_SNACKBAR,
	OPEN_SNACKBAR
} from "../../constants";

export const close = () => {
	return {
		type: CLOSE_SNACKBAR
	}
};

export const showMessage = (message) => {
	return {
		type: OPEN_SNACKBAR,
		payload: {
			message: message
		}
	}
}


// WEBPACK FOOTER //
// ./src/api/snackbar/actions.js